import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {resolveYearItemDefaultOpen} from '../utils/membershipUi';

// Rebranding 2026 · YearItem → gc-sc-year (accordion ivory)
// State interno per open/close (default: anno corrente aperto)

const YearItem = ({year, children, defaultOpen}) => {
  const [open, setOpen] = useState(() => resolveYearItemDefaultOpen(year, defaultOpen));
  const panelId = `gc-year-panel-${year}`;

  return (
    <div className={`gc-sc-year${open ? ' gc-sc-year--open' : ''}`}>
      <button
        type="button"
        className="gc-sc-year__summary"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen(prev => !prev)}
      >
        <b>Anno {year}</b>
        <span className="gc-sc-year__chevron" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="18 15 12 9 6 15"/>
          </svg>
        </span>
      </button>

      {open && (
        <div id={panelId} className="gc-sc-year__body">
          {children}
        </div>
      )}
    </div>
  );
};

YearItem.propTypes = {
  children: PropTypes.node,
  year: PropTypes.number,
  defaultOpen: PropTypes.bool,
};

export default YearItem;
